import { EnvConfig } from '../../../../core/env-config';
import useTeamSettings from '../../hooks/useTeamSettingsService';

export interface ConnectivityAccess {
  /** The region ships VPC Peering and the team has `connectivity_service_enabled`. */
  isVpcPeeringEnabled: boolean;
  /** The region ships Snowflake PrivateLink and the team has `connectivity_service_enabled`. */
  isSnowflakePrivateLinkEnabled: boolean;
  /**
   * The region ships Edge, the team is a Hevo 2.0 team (`active_products` has `hevo_2`) and the team
   * has `connectivity_service_enabled`, the one switch for every kind of private connectivity.
   */
  isProxyAgentsEnabled: boolean;
  /** At least one tab is visible, so the Connectivity page and its sidebar row exist. */
  isConnectivityEnabled: boolean;
}

/**
 * Which Connectivity tabs the team sees. The sidebar row, the Team routes and the page's tab strip
 * all read this one answer, so they cannot disagree.
 */
export function useConnectivityAccess(): ConnectivityAccess {
  const { isConnectivityServiceEnabled, isH2OEnabled } = useTeamSettings();

  const isVpcPeeringEnabled = EnvConfig.isVpcPeeringConnectionEnabled && !!isConnectivityServiceEnabled;
  const isSnowflakePrivateLinkEnabled =
    EnvConfig.isSnowflakePrivateLinkEnabled && !!isConnectivityServiceEnabled;
  // Hevo 2.0 teams with connectivity on, in the regions where the Proxy Agents switch is on.
  const isProxyAgentsEnabled = EnvConfig.isProxyAgentsRegionEnabled && !!isH2OEnabled() && !!isConnectivityServiceEnabled;

  return {
    isVpcPeeringEnabled,
    isSnowflakePrivateLinkEnabled,
    isProxyAgentsEnabled,
    isConnectivityEnabled: isVpcPeeringEnabled || isSnowflakePrivateLinkEnabled || isProxyAgentsEnabled
  };
}
